import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  TextField,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import PropTypes from "prop-types";

export default function ComponentSelectDialog({
  open,
  collegeId,
  clientId,
  courseRow,
  onClose,
  onConfirm,
  onConfirmPDF,
  onOpenMarksEntry,
}) {
  const [components, setComponents] = React.useState([]);
  const [selected, setSelected] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  React.useEffect(() => {
    if (!open) return;

    const fetchComponents = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/exam-internal-component/${clientId}/${collegeId}`
        );

        setComponents(res.data.data || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    fetchComponents();
  }, [open, collegeId]);

  const handleConfirm = () => {
    const component = components.find((c) => String(c.component_id) === String(selected));

    if (!component) return;

    if (courseRow) {
      onConfirm(courseRow, component); // ✅ single-course
    } else {
      onConfirm(component); // ✅ all-courses
    }
  };
  const handleConfirmPDF = () => {
    const component = components.find((c) => String(c.component_id) === String(selected));

    if (!component) return;

    if (courseRow) {
      onConfirmPDF(courseRow, component); // ✅ single-course
    } else {
      onConfirmPDF(component); // ✅ all-courses
    }
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Select Internal Component</DialogTitle>

      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : (
          <TextField
            label="Component"
            name="component_id"
            select
            fullWidth
            value={selected}
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true, displayEmpty: true }}
            onChange={(e) => {
              setSelected(e.target.value);
            }}
          >
            <option value="">Select Component</option>
            {components.map((c) => (
              <option key={c.component_id} value={c.component_id}>
                {c.component_name === "INTERNAL"
                  ? c.component_name
                  : `${c.component_name} (Max: ${c.max_marks})`}
              </option>
            ))}
          </TextField>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          disabled={!selected}
          onClick={() => {
            const component = components.find((c) => String(c.component_id) === String(selected));
            if (!component) return;
            onOpenMarksEntry(courseRow, component); // ✅ PASS BOTH
          }}
          sx={{
            color: "green",
            backgroundColor: "#f8f9fa",
            "&:hover": { backgroundColor: "rgba(152, 152, 232, 0.1)" },
          }}
        >
          Marks Entry
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!selected}
          sx={{
            color: "green",
            backgroundColor: "#faf9f8ff",
            "&:hover": { backgroundColor: "rgba(230, 101, 89, 0.1)" },
          }}
        >
          Students CSV
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirmPDF}
          disabled={!selected}
          sx={{
            color: "green",
            backgroundColor: "#f8f9fa",
            "&:hover": { backgroundColor: "rgba(152, 152, 232, 0.1)" },
          }}
        >
          Students PDF
        </Button>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            "&:hover": { backgroundColor: "#1565c0", color: "#fff" },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ComponentSelectDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onConfirmPDF: PropTypes.func.isRequired,
  collegeId: PropTypes.number.isRequired,
  clientId: PropTypes.number.isRequired,
  courseRow: PropTypes.object,
  onOpenMarksEntry: PropTypes.func.isRequired,
};
